module.exports = __webpack_public_path__ + "static/img/scholarship4.2571054.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/scholarship4.png
// module id = ACeb
// module chunks = 1